module.exports = {
  "country": "CH",
  "artist": "Celine Dion ",
  "song": "Ne partez pas sans moi",
  "year": "1988",
  "place": "1",
  "spotify": "0Kv4i96E41jbULmUajBYOe"
};